"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const vue_1 = require("vue");
const vue_2 = require("vue");
const _hoisted_1 = { class: "form-label d-flex flex-center settings-input" };
const _hoisted_2 = ["value"];
const _hoisted_3 = /*#__PURE__*/ (0, vue_2.createElementVNode)("span", null, "月", -1 /* HOISTED */);
const _hoisted_4 = { class: "form-label d-flex flex-center settings-input" };
const _hoisted_5 = ["value"];
const _hoisted_6 = /*#__PURE__*/ (0, vue_2.createElementVNode)("span", null, "日", -1 /* HOISTED */);
const common_1 = require("../../common/common");
exports.default = (0, vue_1.defineComponent)({
    __name: 'GrantDay',
    props: {
        grantDayMonth: {
            type: Number,
        },
        grantDayDate: {
            type: Number
        }
    },
    emits: ["month", "day"],
    setup(__props, { emit: __emit }) {
        const props = __props;
        const emit = __emit;
        function handleMonthChange(e) {
            const target = e.target;
            const value = parseInt((0, common_1.fullWidthToAscii)(target.value));
            emit("month", value);
        }
        function handleDayChange(e) {
            const target = e.target;
            const value = parseInt((0, common_1.fullWidthToAscii)(target.value));
            emit("day", value);
        }
        return (_ctx, _cache) => {
            return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)(vue_2.Fragment, null, [
                (0, vue_2.createElementVNode)("label", _hoisted_1, [
                    (0, vue_2.createElementVNode)("input", {
                        onChange: handleMonthChange,
                        value: __props.grantDayMonth,
                        class: "form-input form-extra-small",
                        type: "text",
                        placeholder: "1",
                        maxlength: "2"
                    }, null, 40 /* PROPS, NEED_HYDRATION */, _hoisted_2),
                    _hoisted_3
                ]),
                (0, vue_2.createElementVNode)("label", _hoisted_4, [
                    (0, vue_2.createElementVNode)("input", {
                        onChange: handleDayChange,
                        value: __props.grantDayDate,
                        class: "form-input form-extra-small",
                        type: "text",
                        placeholder: "1",
                        maxlength: "2"
                    }, null, 40 /* PROPS, NEED_HYDRATION */, _hoisted_5),
                    _hoisted_6
                ])
            ], 64 /* STABLE_FRAGMENT */));
        };
    }
});
